import { HubExchangeAccountSchema, HubUserSchema, TradeLeaderboardRecordSchema } from "../api";
import { z } from "zod";

export const HubUserSuccessRateAnalysisSchema = z.object({
  hubUser: HubUserSchema.extend({
    exchangeAccounts: z.array(
      z.object({
        id: z.number(),
        exchangeId: z.string(),
        exchangeUserId: z.string().nullable(),
      }),
    ),
  }),
  totalOrders: z.number(),
  successfulOrders: z.number(),
  pendingOrders: z.number(),
  successRate: z.number(),
  pendingRate: z.number(),
});
export type HubUserSuccessRateAnalysis = z.infer<typeof HubUserSuccessRateAnalysisSchema>;
export const HubUserSuccessRateAnalysisResponseSchema = z.array(HubUserSuccessRateAnalysisSchema);
export type HubUserSuccessRateAnalysisResponse = z.infer<typeof HubUserSuccessRateAnalysisResponseSchema>;

export const ExchangeUserSuccessRateAnalysisSchema = z.object({
  exchangeId: z.string(),
  exchangeUserId: z.string(),
  totalOrders: z.number(),
  successfulOrders: z.number(),
  pendingOrders: z.number(),
  successRate: z.number(),
  pendingRate: z.number(),
});
export type ExchangeUserSuccessRateAnalysis = z.infer<typeof ExchangeUserSuccessRateAnalysisSchema>;
export const ExchangeUserSuccessRateAnalysisResponseSchema = z.array(ExchangeUserSuccessRateAnalysisSchema);
export type ExchangeUserSuccessRateAnalysisResponse = z.infer<typeof ExchangeUserSuccessRateAnalysisResponseSchema>;

export const CampaignSuccessRateAnalysisSchema = z.object({
  campaignName: z.string(),
  totalOrders: z.number(),
  successfulOrders: z.number(),
  successRate: z.number(),
  pendingOrders: z.number(),
  pendingRate: z.number(),
});
export type CampaignSuccessRateAnalysis = z.infer<typeof CampaignSuccessRateAnalysisSchema>;
export const CampaignSuccessRateAnalysisResponseSchema = z.array(CampaignSuccessRateAnalysisSchema);
export type CampaignSuccessRateAnalysisResponse = z.infer<typeof CampaignSuccessRateAnalysisResponseSchema>;

export const IpHashSuccessRateAnalysisSchema = z.object({
  originIpHash: z.string(),
  totalOrders: z.number(),
  successfulOrders: z.number(),
  successRate: z.number(),
  pendingOrders: z.number(),
  pendingRate: z.number(),
});
export type IpHashSuccessRateAnalysis = z.infer<typeof IpHashSuccessRateAnalysisSchema>;
export const IpHashSuccessRateAnalysisResponseSchema = z.array(IpHashSuccessRateAnalysisSchema);
export type IpHashSuccessRateAnalysisResponse = z.infer<typeof IpHashSuccessRateAnalysisResponseSchema>;

export const EpochSuccessRateAnalysisSchema = TradeLeaderboardRecordSchema.extend({
  hubUser: HubUserSchema.extend({
    exchangeAccounts: z.array(HubExchangeAccountSchema),
  }),
  totalOrders: z.number(),
  successfulOrders: z.number(),
  successRate: z.number(),
  pendingOrders: z.number(),
  pendingRate: z.number(),
});
export type EpochSuccessRateAnalysis = z.infer<typeof EpochSuccessRateAnalysisSchema>;
export const EpochSuccessRateAnalysisResponseSchema = z.array(EpochSuccessRateAnalysisSchema);
export type EpochSuccessRateAnalysisResponse = z.infer<typeof EpochSuccessRateAnalysisResponseSchema>;
